import { useEffect } from 'react'

export default function useEscapeKey (onEscape) {
  useEffect(() => {
    const handler = event => {
      if (event.key === 'Escape') {
        onEscape()
      }
    }
    document.addEventListener('keydown', handler)
    return () => document.removeEventListener('keydown', handler)
  }, [onEscape])
}
